@if (user && addressForm) {
  <div [formGroup]="addressForm" class="profile_information--content--large">
    <div formArrayName="addresses">
      @for (addressForm of addresses.controls; track addressForm; let i = $index) {
        <div [formGroupName]="i">
          @if (i === showAddressBlock) {
            <div [formGroup]="addressForm">
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@profile-information-description">Description</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="description" />
                  @if (
                    addressForm.get('description').invalid || addressForm.get('description').touched
                  ) {
                    <div>
                      @if (addressForm.get('description').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@profile-information-description-required"
                        >
                          Description required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@profile-information-number-or-name">Number or Name</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="numberOrName" />
                  @if (
                    addressForm.get('numberOrName').invalid ||
                    addressForm.get('numberOrName').touched
                  ) {
                    <div>
                      @if (addressForm.get('numberOrName').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@profile-information-number-or-name-required"
                        >
                          Number or Name required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@profile-information-street">Street</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="street" />
                  @if (addressForm.get('street').invalid || addressForm.get('street').touched) {
                    <div>
                      @if (addressForm.get('street').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@profile-information-street-required"
                        >
                          Street required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@profile-information-town">Town</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="town" />
                  @if (addressForm.get('town').invalid || addressForm.get('town').touched) {
                    <div>
                      @if (addressForm.get('town').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@profile-information-town-required"
                        >
                          Town required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <span i18n="@@profile-information-county">County</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="county" />
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <span i18n="@@profile-information-postcode">Postcode</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="postcode" />
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <div class="profile_information--asterisk">*</div>
                  <span i18n="@@profile-information-country-code">Country code</span>:
                </div>
                <div class="profile_information--input-wrapper">
                  <input class="profile_information--input" formControlName="countryCode" />
                  @if (
                    addressForm.get('countryCode').invalid || addressForm.get('countryCode').touched
                  ) {
                    <div>
                      @if (addressForm.get('countryCode').errors?.required) {
                        <div
                          class="profile_information--error-message"
                          i18n="@@profile-information-country-code-required"
                        >
                          Country Code required
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
              <div class="profile_information--input-container">
                <div class="profile_information--input-label">
                  <span i18n="@@profile-information-primary">Primary</span>:
                </div>
                <div class="profile_information--input-checkbox">
                  <input type="checkbox" formControlName="userPrimary" />
                </div>
              </div>
            </div>
          }
        </div>
      }
      <table class="profile_information--table-container">
        <thead class="profile_information--table-thead">
          <tr>
            <th colspan="3"><span i18n="@@profile-information-address">Address</span>:</th>
          </tr>
        </thead>
        <tbody class="profile_information--table-tbody">
          @for (addressForm of addresses.controls; track addressForm; let i = $index) {
            <tr [formGroupName]="i">
              <td>
                <b
                  >{{ addressForm.get('description').value }}
                  @if (addressForm.get('userPrimary').value === true) {
                    <span i18n="@@profile-information-add-primary">(Primary)</span>
                  }
                  :
                </b>
                {{ addressForm.get('numberOrName').value }}
                {{ addressForm.get('street').value }}
                {{ addressForm.get('town').value }}
                {{ addressForm.get('county').value }}
                {{ addressForm.get('postcode').value }}
              </td>
              <td>
                <button
                  [disabled]="!isEditable"
                  [class.disable-button]="!isEditable"
                  class="mat-stroked-button"
                  (click)="editAddress(i)"
                  i18n="@@Edit"
                >
                  Edit
                </button>
              </td>
              <td>
                <button
                  [disabled]="!isEditable"
                  [class.disable-button]="!isEditable"
                  class="mat-stroked-button"
                  (click)="deleteAddress(i)"
                  i18n="@@Delete"
                >
                  Delete
                </button>
              </td>
            </tr>
          }
        </tbody>
        <tfoot>
          <button
            appButton="small"
            class="add-address-button profile_information--add-button"
            [disabled]="addressForm.invalid && isEditable"
            [class.disable-button]="!isEditable"
            (click)="addAddress(newAddress)"
            i18n="@@Add-new-address"
          >
            Add new address
          </button>
        </tfoot>
      </table>
    </div>
  </div>
}
